import React from 'react';
import ScrollLock from 'react-scrolllock';

import Theme from 'Theme';
import Text from 'components/Text';
import Button from 'components/Button';
import Card from 'components/common/Card';
import Icons from 'components/Icons';
import LoadingSpinner from 'components/LoadingSpinner';

import {
  Flex,
  Header,
  Actions,
  Content,
  TopRight,
  Container,
  DialogTitle,
  InnerContain,
  DisplayButton,
  LoadingContain
} from './Styled';

const FloatingCancel = ({ onClick }) =>
  <TopRight onClick={onClick}>
    <Icons.Cancel
      color={'#eaeef0'}
      size={24}
    />
  </TopRight>;

export const DialogCard = ({
  children,
  Title,
  SubTitle,
  onSubmit,
  onCancel,
  loading,
  hideCancel,
  hideSubmit,
  cancelLabel,
  submitLabel,
  hideActions,
  showFloatingCancel,
  allowSubmit = true
}) => {
  return (
    <ScrollLock>
      <Container>
        <Card.Content>
          <InnerContain>
            {showFloatingCancel && <FloatingCancel onClick={onCancel} />}
            <Flex>
              <Header>
                <DialogTitle>{Title}</DialogTitle>
                <div style={{marginTop: '0.5em'}}>
                  <Text.Default fontWeight={300} size={'16px'}>{SubTitle}</Text.Default>
                </div>
              </Header>
              <Content>
                {loading
                  ? <LoadingContain>
                    <LoadingSpinner large />
                  </LoadingContain>
                  : children}
              </Content>
              {
                !hideActions && !loading &&
                  <Actions>
                    <DisplayButton hide={hideCancel}>
                      <Button.Cancel
                        onClick={onCancel}
                        label={cancelLabel}
                        color={!allowSubmit ? '' : Theme.disabled}
                      />
                    </DisplayButton>
                    {!hideSubmit &&
                      <Button.Default
                        color={Theme.brandColor}
                        disabled={!allowSubmit}
                        onClick={onSubmit}
                        label={submitLabel || 'Submit'}
                      />}
                  </Actions>
              }
            </Flex>
          </InnerContain>
        </Card.Content>
      </Container>
    </ScrollLock>
  );
};

export default DialogCard;
